import { FC } from 'react';
import PruTable from 'src/app/common/components/PruTable/PruTable';
import { useIntl } from 'react-intl';
import { getDefaultDisplayDate } from 'src/app/common/utils';
import { PaginateList } from 'src/app/common/types/common-types';
import { CampaignItem } from 'src/app/modules/PruleadInsightsReporting/types/insights-types';

type CampaignListTableProps = {
  isLoading: boolean;
  campaignList?: PaginateList<CampaignItem>;
  page: number;
  limit: number;
  onRefresh: () => void;
  singleSelect?: boolean;
  onChangePage: (page: number, rowsPerPage: number) => void;
  selectedRows: CampaignItem[];
  onRowsSelected: (campaign: CampaignItem[]) => void;
};

const CampaignListTable: FC<CampaignListTableProps> = ({ singleSelect, isLoading, campaignList, page, limit, onRefresh, onChangePage, selectedRows, onRowsSelected }) => {
  const intl = useIntl();
  const Translation = (id: string) => intl.formatMessage({ id });

  return (
    <PruTable
      key={`${page}-${limit}`}
      defaultPageNumber={page - 1}
      defaultRowsPerPage={limit}
      hideBulkSelectHeader
      singleSelect={singleSelect}
      isLoading={isLoading}
      onRefresh={onRefresh}
      onChangePage={onChangePage}
      title={Translation('pulseleads.campaign.list')}
      operationDef={[]}
      currentSelectedRow={(row: CampaignItem[]) => onRowsSelected(row)}
      updateSelectedRow={selectedRows}
      columnDef={[
        {
          isId: true,
          keyIndex: 'campaignId',
          displayName: Translation('pulseleads.campaign.common.campaignId'),
          renderData: (row) => row.campaignId || '-',
        },
        {
          keyIndex: 'name',
          align: 'center',
          displayName: Translation('pulseleads.campaign.common.name'),
          renderData: (row) => row.name || '-',
        },
        {
          keyIndex: 'startDate',
          align: 'center',
          displayName: Translation('pulseleads.campaign.common.startDate'),
          renderData: (row) => getDefaultDisplayDate(row.startDate) || '-',
        },
        {
          keyIndex: 'endDate',
          align: 'center',
          displayName: Translation('pulseleads.campaign.common.endDate'),
          renderData: (row) => getDefaultDisplayDate(row.endDate) || '-',
        },
        {
          keyIndex: 'marketingOwnerName',
          align: 'center',
          displayName: Translation('pulseleads.campaign.common.marketingOwnerName'),
          renderData: (row) => row.marketingOwnerName || '-',
        },
        {
          keyIndex: 'relativeSourceName',
          align: 'center',
          displayName: Translation('pulseleads.campaign.common.source'),
          renderData: (row) => row.relativeSourceName || '-',
        },
        {
          keyIndex: 'status',
          align: 'center',
          displayName: Translation('pulseleads.campaign.common.status'),
          renderData: (row) => (row.status ? Translation(`pulseleads.campaign.status.option.${row.status}`) : '-'),
        },
        {
          keyIndex: 'updatedBy',
          align: 'center',
          displayName: Translation('pulseleads.campaign.common.updatedBy'),
          renderData: (row) => row.updatedBy,
        },
      ]}
      dataSource={campaignList?.docs}
      totalPages={campaignList?.totalPages}
      totalRecords={campaignList?.totalDocs}
    />
  );
};

export default CampaignListTable;
